import React, {useEffect, useState} from 'react';

//import * as LogFunctions from './../Helpers/LogFunctions';
import {
    ActivityIndicator,
    CCText,
    Modal, TouchableOpacity, TouchableWithoutFeedback,
    View
} from '../../../custom-packages/react-native-components-in-react/react-native-components-in-react';

import ChocoForm from '../../../custom-packages/react-chocoforms/legacy/ChocoForm';
import AppConfig from '../../../AppConfig';

import {useDispatch, useSelector} from 'react-redux';
import {BorderlessButton, DarkButton, ThemeButton} from "../../../custom-packages/react-button-package/ButtonPackage";
import TAuth from "../../../screens/auth/Translations/TAuth";
import Styles from "../../../Styles";
import {GoogleLogin, GoogleOAuthProvider, useGoogleLogin} from "@react-oauth/google";
import {AppleAuthHandler, GetAuthObject} from "../../../authentication/AuthFunctions";
import * as AuthActions from "../../../store/actions/authActions";
import * as UserErrorCodes from "../../../ErrorCodes/UserErrors";
import GoogleSignIn from "../../../custom-packages/sign-in-button/GoogleSignIn";
import {Collapse} from "react-collapse";
import CaretDownIcon from "../../../assets/custom-icons/CaretDownIcon";
import CaretRightIcon from "../../../assets/custom-icons/CaretRightIcon";
import AppleSignInWrapper from "../../../custom-packages/sign-in-button/AppleSignInWrapper";
import {RegisterEvent} from "../../../AnalyticsFunctions";

const TCallWaiterModal = {
    // English
    "enUS": {
        'CALL_WAITER': 'Request a Waiter',
        'CALL_WAITER_LOGIN': 'To request a waiter you need to sign in',
        'CALL_WAITER_DESC': 'Request a waiter to come to your table',
        'CALL': 'Request',
        'CANCEL': 'Cancel',
        'CLOSE': 'Close',
        'WAITER_REQUESTED': 'Waiter Requested!',
        'WAITER_REQUESTED_DESC': 'A waiter is in the way towards your table',
        'OR': 'Or enter your credentials',
        'OTHER_LOGIN_OPTIONS': 'Other Login Options'
    },
    // Spanish
    "esMX": {
        'CALL_WAITER': 'Solicita un mesero',
        'CALL_WAITER_LOGIN': 'Para solicitar un mesero debes de iniciar sesión',
        'CALL_WAITER_DESC': 'Solicita que un mesero vaya a tu mesa',
        'CALL': 'Solicitar',
        'CANCEL': 'Cancelar',
        'CLOSE': 'Cerrar',
        'WAITER_REQUESTED': '¡Mesero Solicitado!',
        'WAITER_REQUESTED_DESC': 'Un mesero se dirige a su mesa',
        'OR': 'O ingresa tus credenciales',
        'OTHER_LOGIN_OPTIONS': 'Otras Opciones de Ingreso'
    }
}

const CallWaiterModal = (props) => {
    const dispatch = useDispatch()
    const auth = useSelector(state => state.Auth);
    const [isSignedIn, setIsSignedIn] = useState(props.testToken ? true : auth && auth.token)

    const [showOtherLoginOptions, setShowOtherLoginOptions] = useState(false)

    const [loading, setLoading] = useState(false);
    const [requested, setRequested] = useState(false);

    const [msg, setMsg] = useState('');
    const [msgType, setMsgType] = useState("info");

    const [loginForm, setLoginForm] = useState({
        controls: {
            Email: {
                elementType: 'input',
                elementConfig: {
                    placeholder: TAuth[AppConfig.lang].YOUR_EMAIL,
                    autoCapitalize: 'none'
                },
                label: TAuth[AppConfig.lang].YOUR_EMAIL,
                value: '',
                validation: {
                    required: true,
                    isEmail: true,
                },
            },
            Password: {
                elementType: 'input',
                elementConfig: {
                    secureTextEntry: true,
                    placeholder: TAuth[AppConfig.lang].YOUR_PASSWORD,
                    autoCapitalize: 'none'
                },
                label: TAuth[AppConfig.lang].YOUR_PASSWORD,
                value: '',
                validation: {
                    required: true,
                },
            }
        },
        isValidForm: false
    });

    useEffect(() => {
        setIsSignedIn(auth && auth.token)
    }, [auth])


    const authSuccessHandler = (json) => {
        const storedAuth = GetAuthObject(json);

        dispatch(AuthActions.saveAuth(storedAuth))
    }

    const googleAuthHandler = async (googleResponse) => {
        try {
            const form = {...loginForm};
            setLoading(true);

            if (googleResponse.access_token) {

                let formData = {};

                formData['GoogleToken'] = googleResponse.access_token;
                formData['Type'] = 'CLIENT';

                const deviceID = localStorage.getItem('deviceID');

                let response = await fetch(AppConfig.URL + "/Account/Login", {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'DeviceID': deviceID
                    },
                    body: JSON.stringify(formData)
                });

                let json = await response.json();

                if (json.success) {
                    await authSuccessHandler(json);
                } else {
                    if (json.errorCode == UserErrorCodes.GOOGLE_EMAIL_NOT_VERIFIED) {
                        form.generalError = TAuth[AppConfig.lang].GOOGLE_EMAIL_NOT_VERIFIED;
                    } else if (json.errorCode == UserErrorCodes.GOOGLE_INFO_NOT_FOUND) {
                        form.generalError = TAuth[AppConfig.lang].GOOGLE_INFO_NOT_FOUND;
                    } else {
                        let response = await fetch(AppConfig.URL + "/Account/Signup", {
                            method: 'POST',
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(formData)
                        });

                        let json = await response.json();

                        if (json.success) {
                            await authSuccessHandler(json, "true");
                        }
                    }
                }
            } else {

            }

            setLoading(false);
        } catch (e) {
            setLoading(false);

            console.log(e);
        }
    }

    const authHandler = async () => {
        setLoading(true);

        const form = {...loginForm};
        let formData = {};

        for (let key in loginForm.controls)
            formData[key] = loginForm.controls[key].value;

        const deviceID = localStorage.getItem('deviceID');

        const response = await fetch(AppConfig.URL + "/Account/Login", {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'DeviceID': deviceID
            },
            body: JSON.stringify(formData)
        });

        const json = await response.json();

        if (json.success) {
            authSuccessHandler(json);
        } else {
            if (json.errorCode == UserErrorCodes.INCORRECT_USERNAME_OR_PASSWORD) {
                form.generalError = {
                    text: TAuth[AppConfig.lang].INCORRECT_USERNAME_OR_PASSWORD,
                    show: true
                }
            } else if (json.errorCode == UserErrorCodes.ACCOUNT_NOT_CONFIRMED) {
                form.generalError = {
                    text: TAuth[AppConfig.lang].ACCOUNT_NOT_VERIFIED,
                    show: true
                }
            } else if (json.errorCode == UserErrorCodes.ACCOUNT_SUSPENDED) {
                form.generalError = {
                    text: TAuth[AppConfig.lang].ACCOUNT_SUSPENDED,
                    show: true
                }
            } else if (json.errorCode == UserErrorCodes.ACCOUNT_BANNED) {
                form.generalError = {
                    text: TAuth[AppConfig.lang].ACCOUNT_BANNED,
                    show: true
                }
            }

            setLoginForm(form);
        }

        setLoading(false)
    }

    if (!isSignedIn) {
        return <Modal
            visible={props.visible}
            onRequestClose={props.onRequestClose}
        >
            <View className={'menu-screen'} style={{ fontFamily: props.config.fontFamily }}>
                {loading ?
                    <ActivityIndicator color={props.config.primaryColor}/>
                    :
                    <View style={{width: '100%'}}>
                        <View style={{marginBottom: 15}}>
                            <h1 style={{ fontWeight: 'bold', color: props.config.primaryColor }}>
                                {TCallWaiterModal[AppConfig.lang].CALL_WAITER}
                            </h1>
                            <CCText>
                                {TCallWaiterModal[AppConfig.lang].CALL_WAITER_LOGIN}
                            </CCText>
                            <View style={{ marginTop: 15}}>
                                <GoogleOAuthProvider
                                    clientId="311231473058-g5ra5hhgep2qai2pk3t6ej8015lcedid.apps.googleusercontent.com"
                                >
                                    <GoogleSignIn
                                        onClick={async (credentialResponse) => {
                                            await googleAuthHandler(credentialResponse);
                                        }}
                                    />
                                </GoogleOAuthProvider>
                                <div style={{height: 10}}></div>
                                <AppleSignInWrapper
                                    redirectUri={'https://tastee.app'}
                                    onClick={async (appleResponse) => {
                                        try {
                                            setLoading(true);

                                            const response = await AppleAuthHandler(appleResponse, 'CLIENT')

                                            if(response.msg) {
                                                const form = { ...loginForm };

                                                form.generalError = {
                                                    text: response.msg,
                                                    show: true
                                                }

                                                setLoginForm(form)
                                            }

                                            if(response.auth)
                                                dispatch(AuthActions.saveAuth(response.auth))
                                        } catch (e) {
                                            console.log(e);
                                        } finally {
                                            setLoading(false);
                                        }
                                    }}
                                />
                            </View>
                            <TouchableWithoutFeedback
                                onPress={() => {
                                    setShowOtherLoginOptions(!showOtherLoginOptions)
                                }}
                                style={{ flexDirection: 'row', margin: '30px 0 0', fontWeight: 'bold'}}
                            >
                                <View style={{ flexDirection: 'row' }}>
                                    {
                                        showOtherLoginOptions ?
                                            <CaretDownIcon size={25} style={{ marginRight: 7 }} />
                                            :
                                            <CaretRightIcon size={25} style={{ marginRight: 7 }} />
                                    }
                                    <CCText>
                                        {TCallWaiterModal[AppConfig.lang].OTHER_LOGIN_OPTIONS}
                                    </CCText>
                                </View>
                            </TouchableWithoutFeedback>
                            <Collapse
                                isOpened={showOtherLoginOptions}
                            >
                                <ChocoForm
                                    lang={AppConfig.lang}
                                    form={loginForm}
                                    onFormChange={(updatedForm) => {
                                        setLoginForm(updatedForm)
                                    }}
                                />
                                <View style={{flexDirection: 'row', justifyContent: 'center'}}>
                                    <ThemeButton
                                        style={{ backgroundColor: props.config.primaryColor }}
                                        text={TAuth[AppConfig.lang].LOGIN}
                                        onPress={authHandler}
                                        disabled={!loginForm.isValidForm}
                                    />
                                </View>
                                <View style={{flexDirection: 'row', justifyContent: 'center'}}>
                                    <BorderlessButton
                                        text={TAuth[AppConfig.lang].SIGN_UP}
                                        textStyle={{ color: props.config.primaryColor }}
                                        to={"/register/client?returnURL=" + window.location.pathname + window.location.search}
                                        onPress={() => {
                                        }}
                                    />
                                </View>
                            </Collapse>
                        </View>
                    </View>
                }
            </View>
        </Modal>;
    }

    if (requested) {
        return <Modal
            visible={props.visible}
            onRequestClose={props.onRequestClose}
            hideHeader={true}
        >
            <View className={'menu-screen'} style={{ fontFamily: props.config.fontFamily }}>
                <View style={{width: '100%'}}>
                    <h1
                        style={{ color: props.config.primaryColor, fontWeight: 'bold' }}
                    >
                        {TCallWaiterModal[AppConfig.lang].WAITER_REQUESTED}
                    </h1>
                    <CCText>
                        {TCallWaiterModal[AppConfig.lang].WAITER_REQUESTED_DESC}
                    </CCText>
                    <View style={{marginTop: 15, flexDirection: 'row', justifyContent: 'center'}}>
                        <DarkButton
                            text={TCallWaiterModal[AppConfig.lang].CLOSE}
                            onPress={props.onRequestClose}
                        />
                    </View>
                </View>
            </View>
        </Modal>
    }

    return <Modal
        visible={props.visible}
        onRequestClose={props.onRequestClose}
        hideHeader={true}
    >
        <View className={'menu-screen'} style={{ fontFamily: props.config.fontFamily }}>
            <View style={{width: '100%'}}>
                <h1
                    style={{ color: props.config.primaryColor, fontWeight: 'bold' }}
                >
                    {TCallWaiterModal[AppConfig.lang].CALL_WAITER}
                </h1>
                <CCText>
                    {TCallWaiterModal[AppConfig.lang].CALL_WAITER_DESC}
                </CCText>
                {msg ?
                    <div className={'alert alert-' + msgType } style={{ marginTop: '1.5rem', textAlign: 'justify', fontSize: '1.15rem' }}>
                        {msg}
                    </div>
                :
                    null
                }
                <View style={{marginTop: 15, flexDirection: 'row', justifyContent: 'flex-end'}}>
                    {loading ?
                        <ActivityIndicator size={42} color={props.config.primaryColor} />
                        :
                        <View style={{flexDirection: 'row'}}>
                            <BorderlessButton
                                text={TCallWaiterModal[AppConfig.lang].CANCEL}
                                onPress={props.onRequestClose}
                            />
                            <View style={{width: 7}}></View>
                            <ThemeButton
                                style={{ backgroundColor: props.config.primaryColor }}
                                text={TCallWaiterModal[AppConfig.lang].CALL}
                                onPress={async () => {
                                    try {
                                        const token = props.testToken ? props.testToken : auth.token;
                                        setLoading(true)
                                        const response = await fetch(AppConfig.URL + "/PublicActions/RequestWaiter?sessionID=" + props.sessionID, {
                                            method: 'GET',
                                            headers: {
                                                'Accept': 'application/json',
                                                'Content-Type': 'application/json',
                                                'Authorization': token
                                            },
                                        });

                                        const json = await response.json();

                                        if (json.success) {
                                            setRequested(true)

                                            setTimeout(() => {
                                                setRequested(false)
                                            }, 60000)
                                        } else {
                                            setMsg(json.msg);
                                            setMsgType(json.msgType);
                                        }
                                    } catch (e) {
                                        console.log(e)
                                    }
                                    setLoading(false)
                                }}
                            />
                        </View>
                    }
                </View>
            </View>
        </View>
    </Modal>
}

export default CallWaiterModal;